import {DateRange} from './date-range';
import {DateRangeType} from './types';

export class ImpactDateRange extends DateRange {
  public getDateRangeTypeOptions() {
    return [DateRangeType.Between, DateRangeType.Since];
  }
}
